var _path, _path2, _ellipse, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path0, _path1, _path10, _path11, _ellipse2, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _g, _g2, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _g3, _g4, _g5, _g6, _g7, _g8, _path30, _path31, _path32, _path33, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEmptyState(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 300,
    height: 186,
    viewBox: "0 0 300 186",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M82.0001 62.6857H81.0001V57.8956H82.0001V56.5005H82.5994V55.5005H85.798V56.5005H88.9966V55.5005H92.1952V56.5005H95.3938V55.5005H98.5924V56.5005H100.191C100.774 56.5009 101.357 56.5054 101.939 56.514L101.954 55.5141C103.132 55.5314 104.306 55.5651 105.477 55.6151L105.435 56.6142C106.602 56.6639 107.765 56.7299 108.925 56.8119L108.995 55.8144C110.17 55.8975 111.341 55.997 112.507 56.1126L112.408 57.1077C113.571 57.2231 114.729 57.3547 115.882 57.5023L116.009 56.5104C117.178 56.6602 118.341 56.8262 119.497 57.0084L119.342 57.9963C120.496 58.1782 121.644 58.3763 122.785 58.5904L122.969 57.6076C124.128 57.8252 125.28 58.0593 126.423 58.3096L126.21 59.2864C127.352 59.5365 128.486 59.8028 129.611 60.0852L129.854 59.1153C130.999 59.4026 132.134 59.7064 133.258 60.0265L132.985 60.9883C134.109 61.3084 135.224 61.6448 136.327 61.9974L136.631 61.0449C137.756 61.4044 138.869 61.7806 139.97 62.1733L139.635 63.1152C140.736 63.5081 141.826 63.9176 142.902 64.3433L143.27 63.4135C144.368 63.8482 145.453 64.2998 146.523 64.768L146.122 65.6842C147.194 66.1529 148.25 66.6383 149.29 67.1403L149.725 66.2396C150.789 66.7531 151.837 67.2837 152.869 67.8313L152.4 68.7144C153.432 69.2626 154.446 69.8277 155.442 70.4095L155.947 69.5461C156.967 70.1424 157.969 70.7562 158.951 71.3872L158.41 72.2284C158.9 72.5431 159.384 72.862 159.863 73.1852C160.35 73.5136 160.83 73.8455 161.304 74.1809L161.882 73.3649C162.858 74.0565 163.807 74.7629 164.727 75.4833L164.111 76.2707C165.04 76.9983 165.94 77.7399 166.81 78.4948L167.465 77.7396C168.369 78.5243 169.241 79.3235 170.082 80.1362L169.386 80.8549C170.233 81.6742 171.046 82.507 171.825 83.3523L172.56 82.6748C173.371 83.5548 174.146 84.4488 174.884 85.3555L174.108 85.9867C174.849 86.8976 175.552 87.8212 176.217 88.7562L177.032 88.177C177.724 89.1513 178.376 90.1385 178.985 91.1372L178.132 91.6582C178.742 92.6572 179.309 93.6674 179.832 94.6875L180.722 94.231C181.266 95.2922 181.765 96.3645 182.217 97.4466L181.294 97.832C181.742 98.9061 182.144 99.9896 182.497 101.081L183.448 100.773C183.815 101.904 184.13 103.043 184.395 104.191L183.421 104.416C183.681 105.542 183.891 106.676 184.049 107.816L185.04 107.678C185.203 108.849 185.312 110.027 185.368 111.209L184.37 111.256C184.386 111.612 184.398 111.968 184.405 112.324L183.073 112.892L183.465 113.812L179.57 115.47L179.179 114.55L177.664 115.194L176.479 114.581L176.02 115.47L172.812 113.812L173.271 112.923L172.202 112.37C172.194 111.981 172.18 111.592 172.158 111.204L171.16 111.259C171.096 110.11 170.972 108.967 170.788 107.831L171.775 107.671C171.587 106.506 171.337 105.348 171.028 104.201L170.062 104.461C169.765 103.358 169.411 102.264 169.001 101.181L169.936 100.827C169.521 99.7311 169.052 98.6473 168.528 97.5772L167.63 98.0165C167.13 96.995 166.58 95.9854 165.98 94.9895L166.837 94.4736C166.237 93.4769 165.589 92.4945 164.893 91.5278L164.082 92.1115C163.419 91.1898 162.712 90.282 161.962 89.3896L162.728 88.7462C161.983 87.86 161.197 86.9894 160.371 86.1356L159.653 86.8309C158.864 86.0156 158.037 85.2154 157.174 84.4316L157.846 83.6911C156.991 82.9156 156.101 82.1563 155.177 81.4143L154.551 82.1941C153.667 81.4839 152.75 80.7894 151.801 80.1117L152.382 79.2979C151.91 78.9606 151.43 78.6275 150.943 78.2987C150.446 77.9637 149.936 77.6294 149.414 77.2964L148.876 78.1397C147.893 77.5132 146.863 76.8911 145.786 76.2773L146.281 75.4085C145.25 74.8212 144.178 74.2418 143.062 73.6734L142.608 74.5644C141.562 74.0315 140.478 73.5083 139.355 72.9977L139.769 72.0874C138.686 71.5945 137.567 71.1133 136.413 70.6463L136.038 71.5733C134.946 71.1312 133.821 70.7019 132.664 70.2875L133.001 69.346C131.877 68.9435 130.723 68.555 129.538 68.1825L129.238 69.1364C128.112 68.7822 126.959 68.4425 125.777 68.119L126.041 67.1545C124.889 66.8394 123.712 66.5395 122.508 66.2565L122.279 67.23C121.126 66.9587 119.948 66.7031 118.745 66.4645L118.94 65.4836C117.769 65.2513 116.576 65.035 115.36 64.836L115.199 65.8228C114.027 65.6311 112.835 65.4555 111.62 65.2971L111.75 64.3055C110.566 64.1512 109.362 64.0131 108.138 63.8923L108.04 64.8874C106.859 64.7709 105.659 64.6705 104.439 64.5873L104.507 63.5896C103.314 63.5082 102.103 63.4431 100.873 63.3951L100.834 64.3944C99.6494 64.3481 98.4473 64.318 97.2279 64.3046L97.2388 63.3047C96.042 63.2916 94.8287 63.2946 93.599 63.3145L93.6152 64.3144C92.4264 64.3335 91.2219 64.3686 90.0018 64.4202L89.9596 63.4211C88.766 63.4715 87.5577 63.5377 86.3345 63.6201L86.4018 64.6179C85.217 64.6978 84.0181 64.7931 82.805 64.9044L82.7136 63.9086C82.4763 63.9304 82.2385 63.9527 82.0001 63.9757V62.6857Z",
    stroke: "#E0E0E0",
    strokeWidth: 2,
    strokeDasharray: "3.64 3.64"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M174.122 109.037L177.112 111.055L177.671 110.226L178.607 110.857L179.544 110.225L180.103 111.055L183.096 109.037L182.537 108.208L185.531 106.19L186.09 107.019L189.083 105.001L188.524 104.172L191.517 102.154L192.076 102.983L195.07 100.965L195.064 100.956H194.771V100.523L194.511 100.136L194.771 99.9604V99.9564H191.181V100.956H187.591V99.9564H184.002V100.956H180.412V99.9564H176.822V100.956H173.232V99.9564H169.642V100.956H166.052V99.9564H162.462V99.9614L162.722 100.136L162.462 100.521V100.956H162.168L162.162 100.965L165.152 102.983L165.712 102.154L168.701 104.172L168.142 105.001L171.132 107.019L171.691 106.19L174.681 108.208L174.122 109.037Z",
    stroke: "#E0E0E0",
    strokeWidth: 2,
    strokeDasharray: "3.64 3.64"
  })), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 98.1441,
    cy: 50.5902,
    rx: 3.23276,
    ry: 0.196466,
    transform: "rotate(-13.1409 98.1441 50.5902)",
    fill: "#9E9E9E"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M103.203 44.6037L75.7231 51.0192C73.0447 51.6445 70.3805 49.974 69.7592 47.3129L66.1332 31.7814C65.5079 29.103 67.1785 26.4387 69.8395 25.8175L97.3197 19.4019C99.9981 18.7766 102.662 20.4472 103.284 23.1083L106.91 38.6398C107.548 41.2967 105.882 43.9784 103.203 44.6037Z",
    fill: "#BDBDBD"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M99.4826 50.2773L96.891 50.8824L88.6841 39.6113L92.667 38.6815L99.4826 50.2773Z",
    fill: "#BDBDBD"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M103.718 36.1045L99.4889 50.2789L91.282 39.0078L103.718 36.1045Z",
    fill: "#BDBDBD"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M103.735 36.1005L99.4889 50.2789L91.282 39.0078L103.735 36.1005Z",
    fill: "#BDBDBD"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M103.225 44.6005L77.919 50.5085C75.2406 51.1338 72.5764 49.4632 71.9551 46.8022L68.3291 31.2707C67.7038 28.5922 69.3744 25.928 72.0354 25.3067L97.3241 19.4028C100.003 18.7775 102.667 20.4481 103.288 23.1091L106.914 38.6406C107.553 41.2976 105.886 43.9792 103.225 44.6005Z",
    fill: "#BDBDBD"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M103.225 44.6005L77.919 50.5085C75.2406 51.1338 72.5764 49.4632 71.9551 46.8022L68.3291 31.2707C67.7038 28.5922 69.3744 25.928 72.0354 25.3067L97.3241 19.4028C100.003 18.7775 102.667 20.4481 103.288 23.1091L106.914 38.6406C107.553 41.2976 105.886 43.9792 103.225 44.6005Z",
    fill: "#E0E0E0"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M97.7909 27.8569L84.9376 30.8576C84.1815 30.9975 83.4655 30.5227 83.3256 29.7667C83.1806 29.0669 83.6206 28.359 84.3122 28.1791L97.1655 25.1784C97.9053 24.969 98.6521 25.4183 98.8574 26.1406C99.0668 26.8804 98.6176 27.6272 97.8952 27.8325C97.8604 27.8407 97.8256 27.8488 97.7909 27.8569Z",
    fill: "white"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    d: "M80.5372 31.8851L74.7106 33.2453C73.9546 33.3852 73.2385 32.9104 73.0987 32.1544C72.9537 31.4546 73.3936 30.7467 74.0853 30.5668L79.9119 29.2066C80.6517 28.9972 81.3985 29.4464 81.6038 30.1688C81.8132 30.9086 81.364 31.6554 80.6416 31.8607C80.5894 31.8729 80.572 31.8769 80.5372 31.8851Z",
    fill: "white"
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    d: "M99.1111 33.5097L77.3875 38.5813C76.6315 38.7211 75.9154 38.2463 75.7756 37.4903C75.6306 36.7906 76.0705 36.0826 76.7622 35.9028L98.4858 30.8312C99.2256 30.6218 99.9724 31.071 100.178 31.7934C100.387 32.5332 99.9379 33.28 99.2155 33.4853C99.1807 33.4934 99.1459 33.5015 99.1111 33.5097Z",
    fill: "white"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M100.428 39.1628L90.3578 41.5139C89.6018 41.6537 88.8857 41.179 88.7459 40.4229C88.6009 39.7232 89.0409 39.0152 89.7325 38.8354L99.803 36.4843C100.543 36.275 101.29 36.7242 101.495 37.4466C101.704 38.1863 101.255 38.9331 100.533 39.1385C100.498 39.1466 100.463 39.1547 100.428 39.1628Z",
    fill: "white"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M73.4706 24.9508C73.4706 24.9508 73.9682 35.8025 74.9955 40.2028C76.0472 44.7076 79.0105 50.2516 79.0105 50.2516L73.9318 51.4373L72.2695 45.8096C70.7098 40.5431 69.9809 35.0643 70.1316 29.5819L70.2355 25.7061L73.4706 24.9508Z",
    fill: "#BDBDBD"
  })), _ellipse2 || (_ellipse2 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 3.82219,
    cy: 0.232288,
    rx: 3.82219,
    ry: 0.232288,
    transform: "matrix(-0.973814 -0.227347 -0.227347 0.973814 24.202 86.4434)",
    fill: "#E6E6E6"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M14.4484 78.7226L46.9391 86.3079C50.1059 87.0472 53.2559 85.0721 53.9904 81.9258L58.2776 63.5624C59.0169 60.3956 57.0417 57.2456 53.8955 56.5111L21.4048 48.9258C18.238 48.1865 15.088 50.1616 14.3535 53.3079L10.0663 71.6713C9.31125 74.8127 11.2816 77.9833 14.4484 78.7226Z",
    fill: "#BDBDBD"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M18.8452 85.4311L21.9092 86.1464L31.6125 72.8203L26.9034 71.7209L18.8452 85.4311Z",
    fill: "#BDBDBD"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M13.8416 68.6709L18.8416 85.4296L28.5449 72.1035L13.8416 68.6709Z",
    fill: "#BDBDBD"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M13.821 68.6661L18.8416 85.4296L28.5449 72.1035L13.821 68.6661Z",
    fill: "#BDBDBD"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M14.4238 78.7163L44.344 85.7014C47.5108 86.4408 50.6608 84.4656 51.3953 81.3194L55.6825 62.956C56.4218 59.7892 54.4466 56.6392 51.3004 55.9046L21.4007 48.9242C18.2339 48.1849 15.0839 50.1601 14.3494 53.3063L10.0623 71.6697C9.30718 74.8112 11.2775 77.9817 14.4238 78.7163Z",
    fill: "#BDBDBD"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M14.4238 78.7163L44.344 85.7014C47.5108 86.4408 50.6608 84.4656 51.3953 81.3194L55.6825 62.956C56.4218 59.7892 54.4466 56.6392 51.3004 55.9046L21.4007 48.9242C18.2339 48.1849 15.0839 50.1601 14.3494 53.3063L10.0623 71.6697C9.30718 74.8112 11.2775 77.9817 14.4238 78.7163Z",
    fill: "#E0E0E0"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M20.8461 58.9232L36.043 62.4711C36.9369 62.6364 37.7835 62.0751 37.9488 61.1813C38.1203 60.3539 37.6001 59.5168 36.7824 59.3042L21.5855 55.7564C20.7108 55.5088 19.8279 56.04 19.5851 56.894C19.3375 57.7687 19.8687 58.6517 20.7228 58.8944C20.7639 58.904 20.805 58.9136 20.8461 58.9232Z",
    fill: "white"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M41.2466 63.6851L48.1355 65.2934C49.0294 65.4587 49.876 64.8974 50.0414 64.0035C50.2128 63.1762 49.6926 62.3391 48.8749 62.1265L41.9859 60.5182C41.1113 60.2706 40.2283 60.8018 39.9855 61.6559C39.7379 62.5305 40.2691 63.4135 41.1232 63.6563C41.1849 63.6707 41.2054 63.6755 41.2466 63.6851Z",
    fill: "white"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M19.2879 65.6057L44.972 71.6019C45.8659 71.7672 46.7125 71.2059 46.8778 70.3121C47.0493 69.4847 46.5291 68.6477 45.7113 68.4351L20.0273 62.4389C19.1526 62.1913 18.2697 62.7225 18.0269 63.5765C17.7793 64.4512 18.3105 65.3341 19.1646 65.5769C19.2057 65.5865 19.2468 65.5961 19.2879 65.6057Z",
    fill: "white"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M17.7282 72.289L29.6348 75.0688C30.5287 75.2341 31.3753 74.6728 31.5406 73.7789C31.7121 72.9515 31.1919 72.1145 30.3742 71.9019L18.4675 69.1222C17.5929 68.8746 16.7099 69.4058 16.4671 70.2598C16.2196 71.1345 16.7507 72.0175 17.6048 72.2602C17.6459 72.2698 17.6871 72.2794 17.7282 72.289Z",
    fill: "white"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M49.6026 55.4872C49.6026 55.4872 49.0143 68.3172 47.7997 73.5198C46.5563 78.8458 43.0527 85.4006 43.0527 85.4006L49.0573 86.8024L51.0227 80.1488C52.8667 73.9221 53.7284 67.4445 53.5503 60.9626L53.4275 56.3802L49.6026 55.4872Z",
    fill: "#BDBDBD"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.5
  }, /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M18.9371 14.3428H45.7631C46.3903 14.3428 46.9211 14.8735 46.9211 15.5007V37.4054C46.9211 38.0326 46.3903 38.5634 45.7631 38.5634H18.9371C18.3099 38.5634 17.7792 38.0326 17.7792 37.4054V15.5007C17.7792 14.8735 18.3099 14.3428 18.9371 14.3428Z",
    fill: "#9E9E9E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.7624 10H50.5884C51.2157 10 51.7464 10.5307 51.7464 11.158V33.0626C51.7464 33.6899 51.2157 34.2206 50.5884 34.2206H23.7624C23.1352 34.2206 22.6045 33.6899 22.6045 33.0626V11.158C22.6045 10.4825 23.1352 10 23.7624 10Z",
    fill: "#9E9E9E"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M23.7624 10H50.5884C51.2157 10 51.7464 10.5307 51.7464 11.158V33.0626C51.7464 33.6899 51.2157 34.2206 50.5884 34.2206H23.7624C23.1352 34.2206 22.6045 33.6899 22.6045 33.0626V11.158C22.6045 10.4825 23.1352 10 23.7624 10Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 34.1355,
    y: 13.1357,
    width: 9.16733,
    height: 2.41245,
    fill: "#9E9E9E"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 34.1355,
    y: 16.0312,
    width: 4.34242,
    height: 14.9572,
    fill: "#9E9E9E"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 43.7863,
    y: 13.1357,
    width: 4.82491,
    height: 2.41245,
    fill: "#9E9E9E"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 43.7863,
    y: 16.0312,
    width: 4.82491,
    height: 14.9572,
    fill: "#9E9E9E"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 38.9609,
    y: 16.0312,
    width: 4.34242,
    height: 14.9572,
    fill: "#9E9E9E"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 25.9344,
    y: 16.0312,
    width: 7.71985,
    height: 14.9572,
    fill: "#9E9E9E"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 25.9344,
    y: 13.1357,
    width: 7.71985,
    height: 2.41245,
    fill: "#9E9E9E"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_4472_16582)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 40.741,
    y: 37.2598,
    width: 46.1103,
    height: 46.1103,
    rx: 23.0551,
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M79.7781 63.5009L78.2625 64.6502L76.751 63.5977C76.751 63.4871 76.751 63.3696 76.7441 63.2521C76.7441 63.1415 76.7441 63.0241 76.7372 62.9066C76.6404 60.1836 75.9493 57.2671 74.5671 55.1315C73.5028 53.4936 72.1413 52.7126 70.6208 52.7126C69.0243 52.7126 67.725 53.6664 66.2875 55.7397C66.2461 55.8019 66.1977 55.8641 66.1562 55.9332C66.1286 55.9678 66.1078 56.0023 66.0802 56.0438C66.0111 56.1475 65.942 56.2511 65.8729 56.3617C65.2509 57.3293 64.6012 58.4558 63.8963 59.6998C63.8341 59.8173 63.765 59.9348 63.7028 60.0523C63.682 60.0799 63.6613 60.1145 63.6475 60.1421L63.5023 60.3978L62.6454 61.9114C60.6342 65.4706 60.1228 66.2861 59.1207 67.62C57.3583 69.9628 55.8517 70.8544 53.8682 70.8544C51.5184 70.8544 50.0256 69.8384 49.1064 68.3042C48.3531 67.0602 47.9868 65.4222 47.9868 63.5562L51.4217 63.6737C51.4217 64.8901 51.6843 65.8162 52.0367 66.3829C52.4929 67.1154 53.1633 67.3988 53.8613 67.3988C54.7528 67.3988 55.5822 67.2122 57.1579 65.0283C58.4226 63.2798 59.9155 60.8332 60.9176 59.292L61.8644 57.8476L62.0648 57.5297L62.2722 57.2187L62.6177 56.6865C63.143 55.8848 63.7097 55.0348 64.3179 54.2193C64.387 54.1225 64.4561 54.0257 64.5321 53.929C64.6012 53.8322 64.6772 53.7355 64.7463 53.6456C65.3683 52.8508 66.0249 52.1114 66.7298 51.5032C68.0084 50.3905 69.3837 49.7754 70.7729 49.7754C73.1019 49.7754 75.3204 51.1231 77.0205 53.6525C78.7552 56.2373 79.6606 59.4579 79.7643 62.8098C79.7712 62.9204 79.7712 63.0379 79.7712 63.1554C79.7781 63.2729 79.7781 63.3834 79.7781 63.5009Z",
    fill: "#0081FB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M50.6937 53.8917C52.2674 51.4693 54.5398 49.7754 57.1453 49.7754C58.6547 49.7754 60.1544 50.2212 61.7211 51.4983C63.4344 52.8944 65.261 55.193 67.5396 58.9817L68.3565 60.3411C70.329 63.6212 71.4507 65.3082 72.1079 66.1043C72.9524 67.1265 73.4798 67.3988 74.2483 67.3988C76.1972 67.3988 76.748 65.6434 76.748 63.597L79.7772 63.5023C79.7772 65.6413 79.3549 67.2129 78.6362 68.4541C77.9423 69.6546 76.5891 70.8544 74.3126 70.8544C72.8972 70.8544 71.6435 70.5475 70.2571 69.242C69.1914 68.2399 67.9453 66.4596 66.9867 64.8597L64.1352 60.1055C62.7046 57.7198 61.3922 55.9401 60.6326 55.135C59.8157 54.2683 58.8067 53.2317 57.1308 53.2317C55.7741 53.2317 54.5812 54.173 53.6171 55.6264L50.6937 53.8917Z",
    fill: "url(#paint0_linear_4472_16582)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M57.1443 53.231C55.7903 53.231 54.5988 54.1723 53.6368 55.6258C52.276 57.6798 51.4425 60.7387 51.4425 63.6767C51.4425 64.8883 51.4404 65.7999 51.788 66.3625L49.1341 68.3066C48.3835 67.0584 47.9868 65.464 47.9868 63.5979C47.9868 60.2045 48.9233 56.6238 50.6947 53.8917C52.2663 51.4693 54.5574 49.7754 57.1581 49.7754L57.1443 53.231Z",
    fill: "url(#paint1_linear_4472_16582)"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.05,
    d: "M62.2723 57.2186L62.0649 57.5296L61.8645 57.8476C62.3552 58.5594 62.915 59.4164 63.5025 60.3978L63.6476 60.1421C63.6614 60.1145 63.6822 60.0799 63.7029 60.0523C63.7651 59.9348 63.8342 59.8173 63.8964 59.6998C63.3228 58.7599 62.7699 57.9236 62.2723 57.2186ZM64.5323 53.9289C64.4562 54.0256 64.3871 54.1224 64.318 54.2191C64.8225 54.8481 65.334 55.5599 65.873 56.3616C65.9422 56.2511 66.0113 56.1474 66.0804 56.0437C66.108 56.0023 66.1288 55.9677 66.1564 55.9331C66.1979 55.864 66.2463 55.8018 66.2877 55.7396C65.7625 54.9656 65.251 54.2675 64.7465 53.6455C64.6774 53.7354 64.6014 53.8321 64.5323 53.9289Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.07,
    d: "M62.2708 57.2185L62.0635 57.5295C62.5542 58.2344 63.1071 59.0776 63.7014 60.0521C63.7636 59.9346 63.8328 59.8171 63.895 59.6996C63.3213 58.7597 62.7684 57.9234 62.2708 57.2185ZM64.3166 54.219C64.8211 54.8479 65.3325 55.5598 65.8716 56.3615C65.9407 56.2509 66.0098 56.1472 66.0789 56.0436C65.5468 55.2557 65.0284 54.5507 64.5308 53.9287C64.4548 54.0255 64.3857 54.1222 64.3166 54.219Z",
    fill: "black"
  }))), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M153.102 176.41H285.606C289.071 176.344 291.895 173.641 292.28 170.081L299.723 77.9126C300.044 74.7481 297.798 71.9791 294.718 71.6494C294.525 71.6494 294.269 71.6494 294.076 71.6494H161.572C158.107 71.7153 155.283 74.4184 154.898 77.9785L147.455 170.147C147.134 173.311 149.38 176.146 152.46 176.476C152.717 176.41 152.909 176.41 153.102 176.41Z",
    fill: "white"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M285.607 176.674H153.103H152.397C149.189 176.344 146.879 173.378 147.2 170.081L154.643 77.9132C154.964 74.2212 157.98 71.3862 161.573 71.3203H294.078C295.746 71.3203 297.35 72.0455 298.441 73.2982C299.596 74.6167 300.109 76.2649 299.981 77.9791L292.538 170.147C292.153 173.773 289.201 176.608 285.607 176.674ZM299.468 77.2538C299.468 74.2211 297.03 71.7817 294.078 71.8476H161.573C158.237 71.9136 155.477 74.4848 155.157 77.9131L147.713 170.081V170.74C147.713 173.773 150.152 176.212 153.103 176.146H285.608C288.945 176.081 291.704 173.509 292.025 170.081L299.468 77.9131V77.2538Z",
    fill: "#00AEEF"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M161.636 71.5842H294.077C297.157 71.5183 299.723 74.0895 299.723 77.2541C299.723 77.4519 299.723 77.7156 299.723 77.9134H154.963C155.284 74.3532 158.171 71.6502 161.636 71.5842Z",
    fill: "#00AEEF"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M290.998 74.7488C290.934 75.408 291.383 76.0014 292.089 76.1333C292.153 76.1333 292.217 76.1333 292.217 76.1333C292.987 76.1333 293.565 75.5399 293.629 74.7488C293.693 74.0895 293.244 73.4302 292.538 73.3643C292.474 73.3643 292.474 73.3643 292.41 73.3643C291.704 73.4302 291.062 74.0235 290.998 74.7488Z",
    fill: "white"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M285.608 74.7488C285.544 75.408 285.993 76.0014 286.699 76.1333C286.763 76.1333 286.827 76.1333 286.827 76.1333C287.533 76.1333 288.175 75.5399 288.239 74.7488C288.303 74.0895 287.854 73.4302 287.148 73.3643C287.084 73.3643 287.084 73.3643 287.02 73.3643C286.314 73.4302 285.672 74.0235 285.608 74.7488Z",
    fill: "white"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M280.217 74.7488C280.153 75.408 280.602 76.0014 281.308 76.1333C281.372 76.1333 281.436 76.1333 281.436 76.1333C282.206 76.1333 282.784 75.5399 282.848 74.7488C282.912 74.0895 282.463 73.4302 281.757 73.3643C281.693 73.3643 281.693 73.3643 281.629 73.3643C280.923 73.4302 280.281 74.0235 280.217 74.7488Z",
    fill: "white"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "M164.654 164.279H276.047C278.807 164.213 281.052 162.104 281.309 159.269L286.571 95.0545C286.827 92.5492 285.031 90.3077 282.592 90.0439C282.4 90.0439 282.272 90.0439 282.079 90.0439H170.621C167.862 90.1099 165.616 92.2196 165.36 95.0545L160.162 159.335C159.905 161.84 161.702 164.082 164.14 164.279C164.333 164.279 164.461 164.345 164.654 164.279Z",
    fill: "#F0F0F0"
  })), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.4
  }, /*#__PURE__*/React.createElement("path", {
    d: "M191.361 102.59H211.372C212.136 102.59 212.753 103.207 212.753 103.971V123.982C212.753 124.746 212.136 125.363 211.372 125.363H191.361C190.597 125.363 189.98 124.746 189.98 123.982V103.971C189.98 103.207 190.597 102.59 191.361 102.59Z",
    fill: "#BDBDBD"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.8,
    d: "M199.484 105.021H205.361C205.508 105.021 205.626 105.139 205.626 105.286V108.606C205.626 108.753 205.508 108.871 205.361 108.871H199.484C199.337 108.871 199.22 108.753 199.22 108.606V105.286C199.22 105.139 199.337 105.021 199.484 105.021Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.6,
    d: "M196.223 113.249H200.896C201.043 113.249 201.16 113.367 201.16 113.513V115.923C201.16 116.07 201.043 116.188 200.896 116.188H196.223C196.077 116.188 195.959 116.07 195.959 115.923V113.513C195.959 113.367 196.077 113.249 196.223 113.249Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.6,
    d: "M204.068 113.249H208.74C208.887 113.249 209.005 113.367 209.005 113.513V115.923C209.005 116.07 208.887 116.188 208.74 116.188H204.068C203.921 116.188 203.803 116.07 203.803 115.923V113.513C203.803 113.367 203.921 113.249 204.068 113.249Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M201.689 119.449H203.893C204.04 119.449 204.158 119.567 204.158 119.714V121.712C204.158 121.859 204.04 121.976 203.893 121.976H201.689C201.542 121.976 201.425 121.859 201.425 121.712V119.714C201.454 119.537 201.542 119.449 201.689 119.449Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M205.158 119.449H207.362C207.509 119.449 207.626 119.567 207.626 119.714V121.712C207.626 121.859 207.509 121.976 207.362 121.976H205.158C205.011 121.976 204.894 121.859 204.894 121.712V119.714C204.894 119.537 205.011 119.449 205.158 119.449Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M208.593 119.449H210.796C210.943 119.449 211.061 119.567 211.061 119.714V121.712C211.061 121.859 210.943 121.976 210.796 121.976H208.593C208.446 121.976 208.328 121.859 208.328 121.712V119.714C208.328 119.537 208.446 119.449 208.593 119.449Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M193.726 119.449H195.93C196.077 119.449 196.194 119.567 196.194 119.714V121.712C196.194 121.859 196.077 121.976 195.93 121.976H193.726C193.579 121.976 193.461 121.859 193.461 121.712V119.714C193.461 119.537 193.579 119.449 193.726 119.449Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M197.456 119.449H199.66C199.807 119.449 199.924 119.567 199.924 119.714V121.712C199.924 121.859 199.807 121.976 199.66 121.976H197.456C197.309 121.976 197.191 121.859 197.191 121.712V119.714C197.221 119.537 197.309 119.449 197.456 119.449Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("g", {
    opacity: 0.3
  }, /*#__PURE__*/React.createElement("path", {
    d: "M206.098 113.249H206.392V111.192H202.572V108.841H202.278V111.192H198.458V113.249H198.752V111.485H206.098V113.249Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M198.459 117.951H194.639V119.42H194.933V118.244H198.459V119.42H198.753V116.188H198.459V117.951Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M206.394 118.244V116.188H206.1V118.244H202.574V119.42H202.868V118.538H206.1V119.42H206.394V118.538H209.626V119.42H209.92V118.244H206.394Z",
    fill: "white"
  })))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.4
  }, /*#__PURE__*/React.createElement("path", {
    d: "M229.628 94.7969H251.555C252.393 94.7969 253.069 95.473 253.069 96.3102V118.237C253.069 119.074 252.393 119.751 251.555 119.751H229.628C228.791 119.751 228.115 119.074 228.115 118.237V96.3424C228.115 95.473 228.791 94.7969 229.628 94.7969Z",
    fill: "#BDBDBD"
  }), /*#__PURE__*/React.createElement("circle", {
    opacity: 0.25,
    cx: 240.584,
    cy: 107.296,
    r: 8.1785,
    transform: "rotate(-80.7816 240.584 107.296)",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.25,
    d: "M240.576 107.29L248.626 108.803C247.788 113.246 243.506 116.144 239.063 115.307C234.619 114.47 231.721 110.188 232.559 105.744C233.299 101.88 236.648 99.1113 240.576 99.0791V107.29Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.25,
    d: "M240.575 107.29V115.468C236.067 115.371 232.461 111.636 232.557 107.096C232.654 102.718 236.196 99.1757 240.575 99.0791V107.29Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.25,
    d: "M240.575 107.29L236.261 100.335C236.905 99.9485 237.581 99.6265 238.322 99.4333C239.03 99.2079 239.803 99.1113 240.543 99.1113L240.575 107.29Z",
    fill: "white"
  }))), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.4
  }, /*#__PURE__*/React.createElement("path", {
    d: "M244.55 133.465H261.539C262.188 133.465 262.712 133.989 262.712 134.637V151.626C262.712 152.275 262.188 152.799 261.539 152.799H244.55C243.902 152.799 243.378 152.275 243.378 151.626V134.637C243.378 133.989 243.902 133.465 244.55 133.465Z",
    fill: "#BDBDBD"
  }), /*#__PURE__*/React.createElement("rect", {
    opacity: 0.25,
    x: 245.897,
    y: 135.984,
    width: 14.3695,
    height: 14.2697,
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.25,
    d: "M245.897 150.255L249.564 147.261L250.762 148.209L254.529 145.016L256.4 146.837L260.266 143.594V150.255H245.897Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.25,
    d: "M245.897 150.254L248.99 144.441L252.608 145.015L255.327 141.473L258.096 141.972L260.266 139.826V150.254H245.897Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.25,
    d: "M245.897 150.254L253.032 149.381L255.352 148.209L257.847 148.458L260.266 147.261V150.254H245.897Z",
    fill: "white"
  }))), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.4
  }, /*#__PURE__*/React.createElement("path", {
    d: "M192.769 136.767H217.038C217.965 136.767 218.713 137.515 218.713 138.442V162.71C218.713 163.637 217.965 164.385 217.038 164.385H192.769C191.843 164.385 191.094 163.637 191.094 162.71V138.442C191.094 137.515 191.843 136.767 192.769 136.767Z",
    fill: "#BDBDBD"
  }), /*#__PURE__*/React.createElement("rect", {
    opacity: 0.25,
    x: 194.622,
    y: 140.366,
    width: 20.5269,
    height: 20.3844,
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    opacity: 0.35,
    x: 196.726,
    y: 152.91,
    width: 2.06695,
    height: 5.30991,
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    opacity: 0.35,
    x: 196.726,
    y: 152.91,
    width: 2.06695,
    height: 7.87578,
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    opacity: 0.35,
    x: 200.288,
    y: 149.204,
    width: 2.06695,
    height: 7.8045,
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    opacity: 0.35,
    x: 200.288,
    y: 149.204,
    width: 2.06695,
    height: 11.582,
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    opacity: 0.35,
    x: 203.852,
    y: 151.485,
    width: 2.06695,
    height: 6.27211,
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    opacity: 0.35,
    x: 203.852,
    y: 151.485,
    width: 2.06695,
    height: 9.30125,
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    opacity: 0.35,
    x: 207.416,
    y: 148.277,
    width: 2.06695,
    height: 8.41033,
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    opacity: 0.35,
    x: 207.416,
    y: 148.277,
    width: 2.06695,
    height: 12.5086,
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    opacity: 0.35,
    x: 210.981,
    y: 143.359,
    width: 2.06695,
    height: 11.7246,
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    opacity: 0.35,
    x: 210.981,
    y: 143.359,
    width: 2.06695,
    height: 17.3908,
    fill: "white"
  }))), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter1_d_4472_16582)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 203.887,
    y: 109.674,
    width: 35.5325,
    height: 35.5325,
    rx: 17.7662,
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M214.321 130.746C213.633 130.757 213.075 131.296 213.061 131.984C213.071 132.672 213.61 133.23 214.299 133.245C214.987 133.234 215.544 132.695 215.559 132.006C215.573 131.292 215.008 130.736 214.321 130.746Z",
    fill: "#AFACAC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M229.415 124.45C230.103 124.439 230.661 123.9 230.675 123.211C230.665 122.524 230.126 121.966 229.437 121.951C228.749 121.962 228.191 122.501 228.177 123.189C228.162 123.878 228.726 124.435 229.415 124.45Z",
    fill: "#AFACAC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M229.4 125.726C228.712 125.736 228.155 126.275 228.141 126.99L228.149 127.626C228.145 129.003 227.031 130.132 225.629 130.129C224.253 130.124 223.124 129.011 223.127 127.609C223.109 124.832 220.877 122.604 218.098 122.597C217.181 122.594 216.327 122.843 215.585 123.264L215.588 119.441L215.584 116.918L215.509 116.947L213.084 118.349L213.093 121.916L213.093 126.3L213.09 128.186C213.101 128.874 213.64 129.432 214.354 129.445C215.042 129.435 215.6 128.896 215.613 128.181L215.607 127.57C215.611 126.194 216.724 125.065 218.126 125.068C219.503 125.072 220.631 126.185 220.628 127.587C220.646 130.364 222.879 132.592 225.657 132.599C226.575 132.602 227.428 132.354 228.171 131.932L228.167 135.756L228.172 138.278L228.247 138.249L230.671 136.848L230.684 134.171L230.686 128.87L230.689 126.983C230.652 126.272 230.088 125.715 229.4 125.726Z",
    fill: "#AFACAC"
  }))), _g8 || (_g8 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter2_d_4472_16582)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M242.798 132.35C237.284 131.075 231.785 134.501 230.51 140C230.064 141.905 230.172 143.886 230.817 145.714H230.817L231.479 147.298L232.353 148.541C235.794 153.042 242.215 153.902 246.716 150.461C251.216 147.02 252.077 140.599 248.636 136.098C247.192 134.209 245.118 132.888 242.798 132.35Z",
    fill: "#6DD400"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M232.734 148.249C234.593 150.661 237.45 152.074 240.492 152.074C245.038 152.089 248.971 148.956 249.969 144.501C250.138 143.779 250.215 143.042 250.215 142.304C250.215 136.928 245.853 132.565 240.461 132.565C239.37 132.565 238.28 132.75 237.235 133.118C232.166 134.9 229.493 140.461 231.275 145.546L231.382 145.837L229.109 148.249V148.28C229.109 148.287 229.109 148.291 229.111 148.293C229.113 148.295 229.117 148.295 229.124 148.295L232.565 148.034L232.734 148.249ZM232.612 148.003C232.612 147.988 232.597 147.988 232.597 147.988L229.186 148.249L231.46 145.868V145.853L231.352 145.561C230.984 144.532 230.799 143.441 230.799 142.35C230.799 136.989 235.131 132.642 240.492 132.642C241.23 132.642 241.967 132.719 242.689 132.888C247.082 133.917 250.2 137.819 250.2 142.335C250.2 147.681 245.869 152.043 240.508 152.043C237.466 152.043 234.624 150.63 232.781 148.234L232.612 148.003Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M240.284 148.15C242.052 148.111 243.518 147.509 244.684 146.344C245.849 145.178 246.452 143.712 246.49 141.944C246.452 140.176 245.849 138.709 244.684 137.544C243.518 136.378 242.052 135.776 240.284 135.737C238.516 135.776 237.05 136.378 235.884 137.544C234.719 138.709 234.116 140.176 234.078 141.944C234.097 143.187 234.417 144.294 235.039 145.266L234.078 148.15L236.962 147.189C237.934 147.81 239.041 148.131 240.284 148.15ZM240.282 146.927C239.195 146.907 238.243 146.606 237.427 146.023L235.62 146.606L236.203 144.8C235.62 143.984 235.319 143.032 235.3 141.944C235.339 140.526 235.824 139.351 236.757 138.418C237.689 137.486 238.864 137 240.282 136.961C241.701 137 242.876 137.486 243.808 138.418C244.741 139.351 245.226 140.526 245.265 141.944C245.226 143.362 244.741 144.537 243.808 145.47C242.876 146.402 241.701 146.888 240.282 146.927ZM242.324 144.77C242.227 144.809 242.081 144.823 241.887 144.814C241.693 144.804 241.227 144.644 240.488 144.333C239.711 143.944 239.104 143.469 238.667 142.905C238.23 142.342 237.987 142.016 237.939 141.929C237.89 141.842 237.783 141.643 237.618 141.332C237.453 141.021 237.375 140.671 237.385 140.283C237.395 139.894 237.468 139.603 237.604 139.409C237.74 139.214 237.856 139.078 237.953 139.001C238.128 138.845 238.274 138.787 238.39 138.826H238.682C238.721 138.826 238.769 138.836 238.827 138.855C238.886 138.874 238.944 138.962 239.002 139.117L239.439 140.283C239.498 140.36 239.498 140.448 239.439 140.545L239.294 140.807L239.031 141.069C238.993 141.108 238.963 141.152 238.944 141.201C238.925 141.249 238.934 141.312 238.973 141.39C239.012 141.468 239.104 141.613 239.25 141.827C239.396 142.041 239.575 142.264 239.789 142.497C240.08 142.75 240.333 142.934 240.547 143.051L241.013 143.284C241.149 143.381 241.256 143.371 241.333 143.255L241.829 142.672C241.887 142.614 241.945 142.585 242.004 142.585C242.062 142.585 242.13 142.594 242.208 142.614L243.227 143.167C243.383 143.226 243.475 143.279 243.504 143.328C243.533 143.376 243.543 143.469 243.533 143.605C243.524 143.74 243.48 143.901 243.402 144.085C243.324 144.27 243.169 144.43 242.936 144.566C242.703 144.702 242.499 144.77 242.324 144.77Z",
    fill: "white"
  }))), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M127.513 51.1216L96.0628 89.0026C92.906 92.8024 93.4321 98.4729 97.2319 101.688C98.3426 102.623 99.6872 103.266 101.09 103.559L152.124 114.607C156.976 115.66 161.77 112.561 162.822 107.709C163.231 105.956 163.056 104.143 162.355 102.448L142.771 53.5184C140.959 48.9001 135.698 46.6787 131.079 48.4909C129.735 49.0755 128.507 49.9524 127.513 51.1216Z",
    fill: "#FBD391"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    d: "M138.387 41.5931L108.982 84.2677C106.001 88.5936 107.112 94.4394 111.379 97.4208C112.607 98.2977 114.01 98.8238 115.53 98.9992L169.604 106.19C174.807 106.891 179.542 103.267 180.243 98.0639C180.477 96.1932 180.185 94.3225 179.366 92.6272L154.697 42.7622C152.359 38.0855 146.688 36.1564 142.011 38.4948C140.55 39.1963 139.264 40.2485 138.387 41.5931Z",
    fill: "#FBD391"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    d: "M116.819 95.1993C114.832 94.907 113.136 93.6794 112.259 91.8671C111.383 90.1718 111.441 88.0673 112.552 86.489L142.015 43.6974C143.125 42.119 144.996 41.3591 146.867 41.6514C148.854 41.9437 150.55 43.1713 151.427 44.9835L176.096 95.0239C176.973 96.7192 176.914 98.8237 175.804 100.402C174.693 101.98 172.822 102.74 170.952 102.448L116.819 95.1993Z",
    fill: "white"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M147.739 57.2598L144.29 56.7921C144.173 56.7336 144.056 56.7336 143.881 56.7336C141.893 56.6167 140.198 58.1951 140.081 60.1827L139.847 64.684V65.1516L140.841 79.1232C141.016 81.2277 142.595 82.8645 144.641 83.1568C146.57 83.4491 148.441 82.163 148.791 80.2339L151.247 66.73C151.305 66.6131 151.305 66.4377 151.305 66.2624L151.539 61.7611C151.597 59.5396 149.96 57.5521 147.739 57.2598ZM144.991 87.0149L144.056 86.898C143.939 86.898 143.764 86.898 143.705 86.8395C141.893 86.781 140.373 88.1256 140.315 89.9378C140.256 91.9838 141.718 93.6791 143.705 93.9714L144.64 94.0883C144.757 94.1468 144.874 94.1468 144.991 94.1468C146.803 94.2637 148.323 92.8607 148.382 91.0485C148.44 89.0025 146.979 87.3072 144.991 87.0149Z",
    fill: "#FBD391"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_4472_16582",
    x: 21.741,
    y: 21.2598,
    width: 84.1104,
    height: 84.1104,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feMorphology", {
    radius: 1,
    operator: "erode",
    in: "SourceAlpha",
    result: "effect1_dropShadow_4472_16582"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 3
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 10
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.2 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_4472_16582"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_4472_16582",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_d_4472_16582",
    x: 184.887,
    y: 93.6738,
    width: 73.5325,
    height: 73.5322,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feMorphology", {
    radius: 1,
    operator: "erode",
    in: "SourceAlpha",
    result: "effect1_dropShadow_4472_16582"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 3
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 10
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.2 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_4472_16582"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_4472_16582",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter2_d_4472_16582",
    x: 210.109,
    y: 116.084,
    width: 59.6356,
    height: 58.4863,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feMorphology", {
    radius: 1,
    operator: "erode",
    in: "SourceAlpha",
    result: "effect1_dropShadow_4472_16582"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 3
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 10
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.2 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_4472_16582"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_4472_16582",
    result: "shape"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_4472_16582",
    x1: 76.5317,
    y1: 60.3149,
    x2: 56.6477,
    y2: 60.3149,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0081FB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.995,
    stopColor: "#0064E1"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_4472_16582",
    x1: 52.5724,
    y1: 65.927,
    x2: 52.5724,
    y2: 52.2026,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0081FB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.995,
    stopColor: "#0064E1"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmptyState);
export default __webpack_public_path__ + "static/media/EmptyState.706811d08f93a7a6d72399a5888b8169.svg";
export { ForwardRef as ReactComponent };